import { render, staticRenderFns } from "./disclosePro.vue?vue&type=template&id=2dde05f7&scoped=true&"
import script from "./disclosePro.vue?vue&type=script&lang=js&"
export * from "./disclosePro.vue?vue&type=script&lang=js&"
import style0 from "./disclosePro.vue?vue&type=style&index=0&id=2dde05f7&scoped=true&lang=css&"
import style1 from "./disclosePro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde05f7",
  null
  
)

export default component.exports